import {
  useWSModalCustom,
  WSCard,
  WSImage,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps
} from "@wingspanhq/fe-component-library";
import image from "../../../assets/add-card-to-digital-wallet.jpg";

const ModalAddCardToDigitalWallet: React.FC<
  WSModalCustomProps<void>
> = props => {
  return (
    <WSModal
      title="Add card to a digital wallet"
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Primary",
            label: "Done",
            onClick: () => {
              props.onClose();
            }
          }
        ]
      }}
      size="S"
      {...props}
    >
      <WSList gap="L">
        <WSImage src={image} placeholder={<></>} />

        <WSCard divider header="Apple Wallet">
          <WSInfoBox transparent title="On iPhone:">
            <ol>
              <li>
                Open the <b>Wallet</b> app.
              </li>
              <li>
                Tap the <b>(+)</b> icon or <b>Add Card</b>.
              </li>
              <li>
                Choose <b>Debit or Credit Card</b>.
              </li>
              <li>
                Add your card by:
                <ul>
                  <li>Scan your card with the camera or</li>
                  <li>Enter the details manually</li>
                </ul>
              </li>
              <li>Complete any verification your bank might require.</li>
            </ol>

            <p>
              Visit{" "}
              <a
                href="https://support.apple.com/apple-pay"
                target="_blank"
                rel="noreferrer"
              >
                Apple Support
              </a>{" "}
              for more info
            </p>
          </WSInfoBox>
        </WSCard>

        <WSCard divider header="Google Wallet">
          <WSInfoBox transparent title="On Android device:">
            <ol>
              <li>
                Open the <b>Google Wallet</b> app.
              </li>
              <li>
                Tap <b>Add to Wallet</b> at the bottom.
              </li>
              <li>
                Select <b>Payment card → New credit or debit card</b>.
              </li>
              <li>
                Add your card by:
                <ul>
                  <li>Scan your card with the camera or</li>
                  <li>Entering the details manually</li>
                </ul>
              </li>
              <li>
                Tap <b>Save and Continue</b>, then accept the{" "}
                <b>Issuer Terms</b>.
              </li>
              <li>Complete any verification your bank might require.</li>
            </ol>

            <p>
              Visit{" "}
              <a
                href="https://support.google.com/wallet/answer/14187106?hl=en"
                target="_blank"
                rel="noreferrer"
              >
                Google Wallet Learning Center
              </a>{" "}
              for more info
            </p>
          </WSInfoBox>
        </WSCard>
      </WSList>
    </WSModal>
  );
};

export const useModalAddCardToDigitalWallet = () =>
  useWSModalCustom(ModalAddCardToDigitalWallet);
